import { useMemo } from "react";
// import ChipStatus from "../ChipStatus";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const useOSTypeOptions = () => {
  return [
    { id: "windows", name: "Windows" },
    { id: "android", name: "Android" }
  ];
};

const OSType = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const options = useOSTypeOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={options}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const OSTypeChip = ({ type }) => {
  const options = useOSTypeOptions();
  const option = useMemo(() => {
    return options.find(option => option.id === type);
  }, [type]);

  if (!option) {
    return null;
  }

  return option.name;

  // return <ChipStatus type="default" label={option.name} />;
};

export default OSType;
